<template>
    <section class="our-stars section" data-sectionThemeDark="false">
        <div class="people">

            <div class="profile"
                v-for=" OurStar   in sortedArrayByName"
                v-bind:key="OurStar.id" 
                v-show="OurStar.active"
            >
                 
                <img v-bind:src="require('../../assets/imgs/global-stars/' + OurStar.image)" />
                <p>{{OurStar.name}} </p>
            </div>
        </div>
            <!--<div class="scroller--element">
                <scroller v-bind="ScrollerConfig" />
            </div>-->
            <SocialIconsMobile v-bind="SocialIconsConfig" />
    </section>
</template>
<script>
import Scroller from '@/components/ui/Scroller'
import SocialIconsMobile from '@/components/ui/SocialIconsMobile'

export default {
    name:"OurStars",
    components: {Scroller,SocialIconsMobile},
    props:["OurStarsList"],
     data(){
        return {
            ScrollerConfig:{
                color:'#c6c6c6',
                animated:true,
                activeState:true,
                scrollTxt:true,
                hideOnMobile:false
            },
            SocialIconsConfig:{
                DarkIconsTrue:true
            }
        }
    },
    computed: {
        // the sortedArray key word gets used in the v-for loop instead of KeepingYouSafeItems
         
        sortedArray: function() {
            function compare(a, b) {
            if (a.sortOrder < b.sortOrder)
                return -1;
            if (a.sortOrder > b.sortOrder)
                return 1;
            return 0;
            }

            return [...this.OurStarsList].sort(compare);
        },
        sortedArrayByName: function() {
            function compare(a, b) {
            if (a.name < b.name)
                return -1;
            if (a.name > b.name)
                return 1;
            return 0;
            }

            return [...this.OurStarsList].sort(compare);
        }
    }


  

}
</script>
<style>

</style>


